import * as Yup from 'yup';

const DIEZMB_FILE_SIZE = 10 * 1024 * 1024;
const EXCEL_FORMATS = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
];

const email = Yup.string().email('Correo inválido').required('Requerido');

const excel = Yup.mixed().required('El archivo es requerido.')
                .test("fileSize", "El archivo es demasiado grande.", value => value && value.size <= DIEZMB_FILE_SIZE)
                .test("fileFormat", "El archivo no es formato Excel.", value => value && EXCEL_FORMATS.includes(value.type));

/* Esquemas de validacion de Yup para utilizar en Formik */
export const cargarArchivoFormSchema = Yup.object({
    file: excel
});